import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;

import { observable, makeObservable, runInAction, computed } from "mobx";
import React from "react";
import i18next from "i18next";
import moment from "moment-timezone";
import { formatAMPM } from "@dp/common";
var CurbsideModel = (_class = /*#__PURE__*/function () {
  function CurbsideModel(_appMessages) {
    var _this = this;

    _classCallCheck(this, CurbsideModel);

    _initializerDefineProperty(this, "_inputMode", _descriptor, this);

    _initializerDefineProperty(this, "_parkingSpotValue", _descriptor2, this);

    _initializerDefineProperty(this, "_parkingSignInputFieldRef", _descriptor3, this);

    _initializerDefineProperty(this, "_parkingDescription", _descriptor4, this);

    _initializerDefineProperty(this, "_vehicleType", _descriptor5, this);

    _initializerDefineProperty(this, "_vehicleColor", _descriptor6, this);

    _initializerDefineProperty(this, "_showModal", _descriptor7, this);

    _initializerDefineProperty(this, "_checkSummary", _descriptor8, this);

    _initializerDefineProperty(this, "_restaurant", _descriptor9, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor10, this);

    _initializerDefineProperty(this, "_restaurantOffCanvasShown", _descriptor11, this);

    _initializerDefineProperty(this, "_vehicleOffCanvasShown", _descriptor12, this);

    _initializerDefineProperty(this, "_curbsideToken", _descriptor13, this);

    _initializerDefineProperty(this, "_orderSummary", _descriptor14, this);

    _initializerDefineProperty(this, "_checkInSource", _descriptor15, this);

    _initializerDefineProperty(this, "_geoFenceEntryTimestamp", _descriptor16, this);

    _defineProperty(this, "_appMessages", void 0);

    makeObservable(this);
    this._appMessages = _appMessages;
    runInAction(function () {
      _this._restaurantOffCanvasShown = false;
      _this._vehicleOffCanvasShown = false;
      _this._inputMode = "SIGNAGEINPUT";
    });
    this.parkingSignInputFieldRef = /*#__PURE__*/React.createRef();
  }

  _createClass(CurbsideModel, [{
    key: "setCheckSummaryData",
    value: function setCheckSummaryData(checkSummary) {
      var _this2 = this;

      runInAction(function () {
        var _checkSummary$orderSu, _checkSummary$orderSu2, _checkSummary$orderSu3, _checkSummary$orderSu4;

        _this2._checkSummary = checkSummary;
        _this2._vehicleType = checkSummary === null || checkSummary === void 0 ? void 0 : (_checkSummary$orderSu = checkSummary.orderSummary) === null || _checkSummary$orderSu === void 0 ? void 0 : (_checkSummary$orderSu2 = _checkSummary$orderSu.vehicleInformation) === null || _checkSummary$orderSu2 === void 0 ? void 0 : _checkSummary$orderSu2.vehicleType;
        _this2._vehicleColor = checkSummary === null || checkSummary === void 0 ? void 0 : (_checkSummary$orderSu3 = checkSummary.orderSummary) === null || _checkSummary$orderSu3 === void 0 ? void 0 : (_checkSummary$orderSu4 = _checkSummary$orderSu3.vehicleInformation) === null || _checkSummary$orderSu4 === void 0 ? void 0 : _checkSummary$orderSu4.vehicleColor;
      });
    }
  }, {
    key: "setRestaurantData",
    value: function setRestaurantData(restaurant) {
      var _this3 = this;

      runInAction(function () {
        _this3._restaurant = restaurant;

        if ((restaurant === null || restaurant === void 0 ? void 0 : restaurant.numParkingSpots) > 0) {
          _this3._inputMode = "SIGNAGEINPUT";
        } else {
          _this3._inputMode = "DESCRIPTIONINPUT";
        }
      });
    }
  }, {
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this4 = this;

      runInAction(function () {
        _this4._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setVehicleDetails",
    value: function setVehicleDetails() {
      if (this.isVehicleDataValid()) {
        this.vehicleOffCanvasShown = false;
      }
    }
  }, {
    key: "isVehicleDataValid",
    value: function isVehicleDataValid() {
      var isValid = true;

      if (!this._vehicleType) {
        this._appMessages.showError("", "Please select a vehicle type.", null, {
          undismissible: true,
          okBtnText: "OK"
        });

        isValid = false;
      }

      if (!this._vehicleColor) {
        this._appMessages.showError("", "Please select a vehicle color.", null, {
          undismissible: true,
          okBtnText: "OK"
        });

        isValid = false;
      }

      if (!this._vehicleType && !this._vehicleColor) {
        this._appMessages.showError("", "Please select a vehicle type and color.", null, {
          undismissible: true,
          okBtnText: "OK"
        });

        isValid = false;
      }

      return isValid;
    }
  }, {
    key: "isCheckinDataValid",
    value: function isCheckinDataValid() {
      var isValid = this.isVehicleDataValid();

      if (isValid) {
        if (this._inputMode === "SIGNAGEINPUT") {
          if (!this._parkingSpotValue) {
            this._appMessages.showError("", "Please enter a parking spot number.", null, {
              undismissible: true,
              showIconBox: false,
              okBtnText: "Add",
              okBtnOnClick: function okBtnOnClick() {//TODO: set Focus by using a ref on the parkingValue
              }
            });

            isValid = false;
          } else if (this._parkingSpotValue > this.maxParkingSpotNumber || this._parkingSpotValue === 0) {
            this._appMessages.showError("", "Invalid parking spot number. The available parking spot range is 1 to " + this.maxParkingSpotNumber + ".", null, {
              undismissible: true,
              showIconBox: false,
              okBtnText: "Update",
              okBtnOnClick: function okBtnOnClick() {//TODO: set Focus by using a ref on the parkingValue
              }
            });

            isValid = false;
          }
        } else {
          if (!this._parkingDescription) {
            this._appMessages.showError("", "Please enter your parking spot details.", null, {
              undismissible: true,
              showIconBox: false,
              okBtnText: "Add",
              okBtnOnClick: function okBtnOnClick() {//TODO: set Focus by using a ref on the parkingDescription
              }
            });

            isValid = false;
          } else if (this._parkingDescription.length >= this.maxCharacterLimitForDesc) {
            this._appMessages.showError("", "Please only use up to " + this.maxCharacterLimitForDesc + " characters for the parking description.", null, {
              undismissible: true,
              showIconBox: false,
              okBtnText: "Update",
              okBtnOnClick: function okBtnOnClick() {//TODO: set Focus by using a ref on the parkingDescription
              }
            });

            isValid = false;
          }
        }
      }

      return isValid;
    }
  }, {
    key: "updateOrderStatus",
    value: function updateOrderStatus(status) {
      var _this5 = this;

      runInAction(function () {
        _this5.checkSummary.orderSummary.orderStatus = status;
      });
    }
  }, {
    key: "resetModel",
    value: function resetModel() {
      var _this6 = this;

      runInAction(function () {
        _this6._checkSummary = null;
        _this6._curbsideToken = null;
      });
    }
  }, {
    key: "maxParkingSpotNumber",
    get: function get() {
      var _this$restaurant;

      return (_this$restaurant = this.restaurant) === null || _this$restaurant === void 0 ? void 0 : _this$restaurant.numParkingSpots;
    }
  }, {
    key: "isNumParkingSpotsAvailable",
    get: function get() {
      var _this$restaurant2;

      return ((_this$restaurant2 = this.restaurant) === null || _this$restaurant2 === void 0 ? void 0 : _this$restaurant2.numParkingSpots) > 0;
    }
  }, {
    key: "maxCharacterLimitForDesc",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$, _this$_appAttributes2, _this$_appAttributes3;

      return (_this$_appAttributes = this._appAttributes) !== null && _this$_appAttributes !== void 0 && (_this$_appAttributes$ = _this$_appAttributes.configs) !== null && _this$_appAttributes$ !== void 0 && _this$_appAttributes$.curbsideInstructionsMaxLength ? Number((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.curbsideInstructionsMaxLength) : 250; //TODO;
    }
  }, {
    key: "vehicleTypes",
    get: function get() {
      var _this$_appAttributes4;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.carTypeList;
    }
  }, {
    key: "vehicleColors",
    get: function get() {
      var _this$_appAttributes5;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.carColorList;
    }
  }, {
    key: "brandName",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7, _this$_appAttributes8;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.concept) === null || _this$_appAttributes7 === void 0 ? void 0 : (_this$_appAttributes8 = _this$_appAttributes7.conceptCode) === null || _this$_appAttributes8 === void 0 ? void 0 : _this$_appAttributes8.toLowerCase();
    }
  }, {
    key: "orderStatus",
    get: function get() {
      var _this$checkSummary, _this$checkSummary$or;

      return (_this$checkSummary = this.checkSummary) === null || _this$checkSummary === void 0 ? void 0 : (_this$checkSummary$or = _this$checkSummary.orderSummary) === null || _this$checkSummary$or === void 0 ? void 0 : _this$checkSummary$or.orderStatus;
    }
  }, {
    key: "totalAmount",
    get: function get() {
      var _this$checkSummary2, _this$checkSummary2$o;

      if ((_this$checkSummary2 = this.checkSummary) !== null && _this$checkSummary2 !== void 0 && (_this$checkSummary2$o = _this$checkSummary2.orderSummary) !== null && _this$checkSummary2$o !== void 0 && _this$checkSummary2$o.tipAmount) {
        var _this$checkSummary3, _this$checkSummary3$o, _this$checkSummary4, _this$checkSummary4$o;

        var orderTotal = parseFloat((_this$checkSummary3 = this.checkSummary) === null || _this$checkSummary3 === void 0 ? void 0 : (_this$checkSummary3$o = _this$checkSummary3.orderSummary) === null || _this$checkSummary3$o === void 0 ? void 0 : _this$checkSummary3$o.totalAmount) + parseFloat((_this$checkSummary4 = this.checkSummary) === null || _this$checkSummary4 === void 0 ? void 0 : (_this$checkSummary4$o = _this$checkSummary4.orderSummary) === null || _this$checkSummary4$o === void 0 ? void 0 : _this$checkSummary4$o.tipAmount);
        return parseFloat(orderTotal.toString()).toFixed(2);
      } else {
        var _this$checkSummary5, _this$checkSummary5$o;

        return parseFloat((_this$checkSummary5 = this.checkSummary) === null || _this$checkSummary5 === void 0 ? void 0 : (_this$checkSummary5$o = _this$checkSummary5.orderSummary) === null || _this$checkSummary5$o === void 0 ? void 0 : _this$checkSummary5$o.totalAmount).toFixed(2);
      }
    }
  }, {
    key: "orderID",
    get: function get() {
      var _this$checkSummary6, _this$checkSummary6$o, _this$checkSummary6$o2, _this$checkSummary6$o3, _this$checkSummary7, _this$checkSummary7$o, _this$checkSummary7$o2;

      var dashID = (_this$checkSummary6 = this.checkSummary) === null || _this$checkSummary6 === void 0 ? void 0 : (_this$checkSummary6$o = _this$checkSummary6.orderSummary) === null || _this$checkSummary6$o === void 0 ? void 0 : (_this$checkSummary6$o2 = _this$checkSummary6$o.orderIDs) === null || _this$checkSummary6$o2 === void 0 ? void 0 : (_this$checkSummary6$o3 = _this$checkSummary6$o2.orderID) === null || _this$checkSummary6$o3 === void 0 ? void 0 : _this$checkSummary6$o3.filter(function (orderID) {
        return orderID.source === "DASH";
      });
      var dpID = (_this$checkSummary7 = this.checkSummary) === null || _this$checkSummary7 === void 0 ? void 0 : (_this$checkSummary7$o = _this$checkSummary7.orderSummary) === null || _this$checkSummary7$o === void 0 ? void 0 : (_this$checkSummary7$o2 = _this$checkSummary7$o.orderIDs) === null || _this$checkSummary7$o2 === void 0 ? void 0 : _this$checkSummary7$o2.orderID.filter(function (orderID) {
        return orderID.source === "DP";
      });

      if (dpID && dpID.length > 0) {
        var _dpID$;

        return (_dpID$ = dpID[0]) === null || _dpID$ === void 0 ? void 0 : _dpID$.ID;
      } else if (dashID) {
        var _dashID$;

        return (_dashID$ = dashID[0]) === null || _dashID$ === void 0 ? void 0 : _dashID$.ID.toUpperCase();
      } else {
        return null;
      }
    }
  }, {
    key: "id",
    get: function get() {
      var _this$checkSummary8, _this$checkSummary8$o, _this$checkSummary9, _this$checkSummary9$o, _this$checkSummary9$o2;

      var checkNumber = (_this$checkSummary8 = this.checkSummary) === null || _this$checkSummary8 === void 0 ? void 0 : (_this$checkSummary8$o = _this$checkSummary8.orderSummary) === null || _this$checkSummary8$o === void 0 ? void 0 : _this$checkSummary8$o.checkNumber;
      var dpID = (_this$checkSummary9 = this.checkSummary) === null || _this$checkSummary9 === void 0 ? void 0 : (_this$checkSummary9$o = _this$checkSummary9.orderSummary) === null || _this$checkSummary9$o === void 0 ? void 0 : (_this$checkSummary9$o2 = _this$checkSummary9$o.orderIDs) === null || _this$checkSummary9$o2 === void 0 ? void 0 : _this$checkSummary9$o2.orderID.filter(function (orderID) {
        return orderID.source === "DP";
      });

      if (dpID && dpID.length > 0) {
        var _dpID$2;

        return "Order #".concat((_dpID$2 = dpID[0]) === null || _dpID$2 === void 0 ? void 0 : _dpID$2.ID);
      } else if (checkNumber) {
        return "Check #".concat(checkNumber);
      } else {
        return null;
      }
    }
  }, {
    key: "dashOrderID",
    get: function get() {
      var _this$checkSummary10, _this$checkSummary10$, _this$checkSummary10$2;

      return (_this$checkSummary10 = this.checkSummary) === null || _this$checkSummary10 === void 0 ? void 0 : (_this$checkSummary10$ = _this$checkSummary10.orderSummary) === null || _this$checkSummary10$ === void 0 ? void 0 : (_this$checkSummary10$2 = _this$checkSummary10$.orderIDs) === null || _this$checkSummary10$2 === void 0 ? void 0 : _this$checkSummary10$2.orderID.filter(function (orderID) {
        return orderID.source === "DASH";
      })[0].ID;
    }
  }, {
    key: "restaurant",
    get: function get() {
      return this._restaurant;
    }
  }, {
    key: "parkingSpotNumberVisible",
    get: function get() {
      return this.inputMode === "SIGNAGEINPUT";
    }
  }, {
    key: "zipCodeFormatted",
    get: function get() {
      var _this$restaurant3, _this$restaurant3$con, _this$restaurant3$con2;

      return (_this$restaurant3 = this.restaurant) === null || _this$restaurant3 === void 0 ? void 0 : (_this$restaurant3$con = _this$restaurant3.contactDetail) === null || _this$restaurant3$con === void 0 ? void 0 : (_this$restaurant3$con2 = _this$restaurant3$con.address) === null || _this$restaurant3$con2 === void 0 ? void 0 : _this$restaurant3$con2.zipCode;
    }
  }, {
    key: "inputMode",
    get: function get() {
      return this._inputMode;
    },
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._inputMode = val;
      });
    }
  }, {
    key: "parkingSpotValue",
    get: function get() {
      return this._parkingSpotValue;
    },
    set: function set(val) {
      var _this8 = this;

      runInAction(function () {
        var _val$toString;

        if (val === null || val === undefined) {
          _this8._parkingSpotValue = val;
        } else if ((val === null || val === void 0 ? void 0 : (_val$toString = val.toString()) === null || _val$toString === void 0 ? void 0 : _val$toString.length) <= 2 && !isNaN(val) && parseInt(val + "") !== 0) {
          _this8._parkingSpotValue = val;
        }
      });
    }
  }, {
    key: "isParkingSpotAvailable",
    get: function get() {
      if (this._inputMode === "SIGNAGEINPUT") {
        return this.parkingSpotValue;
      } else {
        return null;
      }
    }
  }, {
    key: "parkingSignInputFieldRef",
    get: function get() {
      return this._parkingSignInputFieldRef;
    },
    set: function set(_parkingSignInputFieldRef) {
      var _this9 = this;

      runInAction(function () {
        _this9._parkingSignInputFieldRef = _parkingSignInputFieldRef;
      });
    }
  }, {
    key: "parkingDescription",
    get: function get() {
      return this._parkingDescription;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._parkingDescription = val.substring(0, _this10.maxCharacterLimitForDesc);
      });
    }
  }, {
    key: "isParkingDescriptionAvailable",
    get: function get() {
      if (this._inputMode === "DESCRIPTIONINPUT") {
        return this.parkingDescription;
      } else {
        return null;
      }
    }
  }, {
    key: "vehicleType",
    get: function get() {
      return this._vehicleType;
    },
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._vehicleType = val;
      });
    }
  }, {
    key: "vehicleColor",
    get: function get() {
      return this._vehicleColor;
    },
    set: function set(val) {
      var _this12 = this;

      runInAction(function () {
        _this12._vehicleColor = val;
      });
    }
  }, {
    key: "vehicleSVG",
    get: function get() {
      switch (this.vehicleType) {
        case "Car":
          return this.vehicleCarSVG;

        case "SUV":
          return this.vehicleSUVSVG;

        case "Truck":
          return this.vehicleTruckSVG;

        case "Van":
          return this.vehicleVanSVG;

        case "Other":
          return this.vehicleOtherSVG;

        default:
          {
            return this.vehicleCarSVG;
          }
      }
    }
  }, {
    key: "vehicleCarSVG",
    get: function get() {
      return "<svg class=\"ico-vehicle\" width=\"38\" height=\"17\" viewBox=\"0 0 38 17\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M1.13721 7.77979C1.1372 7.2275 1.58492 6.77979 2.13721 6.77979L34.775 6.77979C35.8243 6.77979 36.6952 7.59068 36.7699 8.63729L37.0607 12.7085C37.1021 13.2874 36.6436 13.7798 36.0633 13.7798H30.6372C30.6372 13.7798 29.5142 11.3813 28.1372 11.2798C26.6466 11.1699 25.2394 13.7798 25.2394 13.7798H11.1372C11.1372 13.7798 10.1372 11.2798 8.1372 11.2798C6.1372 11.2798 5.6372 13.7798 5.6372 13.7798H2.13723C1.58495 13.7798 1.13723 13.3321 1.13723 12.7798L1.13721 7.77979Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 8.58984C0.5 7.20913 1.61929 6.08984 3 6.08984H33.4C35.8853 6.08984 37.9 8.10456 37.9 10.5898V11.8698C37.9 13.2506 36.7807 14.3698 35.4 14.3698H30.64V13.3698H35.4C36.2284 13.3698 36.9 12.6983 36.9 11.8698V10.5898C36.9 8.65685 35.333 7.08984 33.4 7.08984H3C2.17157 7.08984 1.5 7.76142 1.5 8.58984V11.8698C1.5 12.6983 2.17157 13.3698 3 13.3698H5.68V14.3698H3C1.61929 14.3698 0.5 13.2506 0.5 11.8698V8.58984ZM10.88 13.3698H24.92V14.3698H10.88V13.3698Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.1407 1.88029C17.6054 1.37324 13.5121 1.37324 10.9768 1.88028C10.6964 1.93635 10.3137 2.12252 9.86801 2.44439C9.43097 2.76005 8.96777 3.1812 8.52949 3.66168C7.64201 4.63459 6.91525 5.78547 6.6838 6.71126C6.61682 6.97916 6.34536 7.14204 6.07746 7.07507C5.80956 7.00809 5.64668 6.73662 5.71366 6.46873C6.00221 5.31452 6.85059 4.01836 7.79069 2.98776C8.26619 2.46648 8.77988 1.99675 9.2825 1.63373C9.77652 1.27691 10.2962 0.996602 10.7807 0.899701C13.4454 0.366763 17.6721 0.366768 20.3368 0.899707C21.7577 1.18388 23.5277 2.28919 25.0209 3.39291C26.5353 4.5122 27.8542 5.69834 28.3923 6.23644C28.5875 6.4317 28.5875 6.74829 28.3923 6.94355C28.197 7.13881 27.8804 7.13881 27.6852 6.94355C27.1833 6.44165 25.9022 5.28779 24.4265 4.19708C22.9298 3.0908 21.3198 2.11611 20.1407 1.88029Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.27869 15.99C9.44954 15.99 10.3987 15.0408 10.3987 13.87C10.3987 12.6992 9.44954 11.75 8.27869 11.75C7.10785 11.75 6.15869 12.6992 6.15869 13.87C6.15869 15.0408 7.10785 15.99 8.27869 15.99ZM8.27869 16.99C10.0018 16.99 11.3987 15.5931 11.3987 13.87C11.3987 12.1469 10.0018 10.75 8.27869 10.75C6.55556 10.75 5.15869 12.1469 5.15869 13.87C5.15869 15.5931 6.55556 16.99 8.27869 16.99Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.0404 15.99C29.2113 15.99 30.1604 15.0408 30.1604 13.87C30.1604 12.6992 29.2113 11.75 28.0404 11.75C26.8696 11.75 25.9204 12.6992 25.9204 13.87C25.9204 15.0408 26.8696 15.99 28.0404 15.99ZM28.0404 16.99C29.7635 16.99 31.1604 15.5931 31.1604 13.87C31.1604 12.1469 29.7635 10.75 28.0404 10.75C26.3173 10.75 24.9204 12.1469 24.9204 13.87C24.9204 15.5931 26.3173 16.99 28.0404 16.99Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6821 6.58965L18.6821 1.38965L19.6821 1.38965L19.6821 6.58965L18.6821 6.58965Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.3975 6.58965L11.3975 1.38965L12.3975 1.38965L12.3975 6.58965L11.3975 6.58965Z\" />\n            </svg>";
    }
  }, {
    key: "vehicleSUVSVG",
    get: function get() {
      return "<svg class=\"ico-vehicle\" width=\"38\" height=\"21\" viewBox=\"0 0 38 21\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.89644 4.09998C5.38087 4.09998 4.90142 4.36476 4.62685 4.80113L2.01047 8.95931L1.61007 14.9653C1.56179 15.6895 2.03887 16.3443 2.74294 16.5203L5.28125 17.1549C5.54915 17.2219 5.71203 17.4933 5.64505 17.7612C5.57808 18.0291 5.30661 18.192 5.03871 18.125L2.50041 17.4905C1.32695 17.1971 0.531824 16.1057 0.612284 14.8988L1.02109 8.76672C1.02661 8.68397 1.05262 8.60389 1.09679 8.53369L3.78046 4.26857C4.23808 3.54128 5.03715 3.09998 5.89644 3.09998H19.2C20.6859 3.09998 22.3315 4.0154 23.7931 5.13782C25.2221 6.23529 26.5658 7.6023 27.5543 8.75904L34.1601 10.0556C35.3875 10.2965 36.393 11.1741 36.7977 12.3576L37.482 14.3587C37.7689 15.1976 37.8016 16.1025 37.576 16.96L37.3635 17.7672C37.3057 17.9869 37.1071 18.14 36.88 18.14H32.2C31.9238 18.14 31.7 17.9161 31.7 17.64C31.7 17.3638 31.9238 17.14 32.2 17.14H36.4945L36.6089 16.7055C36.7844 16.0386 36.759 15.3347 36.5358 14.6822L35.8515 12.6812C35.5625 11.8358 34.8442 11.209 33.9675 11.0369L27.19 9.70661C27.0782 9.68468 26.9773 9.62526 26.9039 9.53818C25.9386 8.39271 24.597 7.01614 23.184 5.93093C21.7475 4.82775 20.3316 4.09998 19.2 4.09998H5.89644ZM10.38 17.64C10.38 17.3638 10.6038 17.14 10.88 17.14H26.48C26.7561 17.14 26.98 17.3638 26.98 17.64C26.98 17.9161 26.7561 18.14 26.48 18.14H10.88C10.6038 18.14 10.38 17.9161 10.38 17.64Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.76185 19.76C8.93269 19.76 9.88185 18.8109 9.88185 17.64C9.88185 16.4692 8.93269 15.52 7.76185 15.52C6.591 15.52 5.64185 16.4692 5.64185 17.64C5.64185 18.8109 6.591 19.76 7.76185 19.76ZM7.76185 20.76C9.48498 20.76 10.8818 19.3631 10.8818 17.64C10.8818 15.9169 9.48498 14.52 7.76185 14.52C6.03872 14.52 4.64185 15.9169 4.64185 17.64C4.64185 19.3631 6.03872 20.76 7.76185 20.76Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.1776 19.76C30.3485 19.76 31.2976 18.8109 31.2976 17.64C31.2976 16.4692 30.3485 15.52 29.1776 15.52C28.0068 15.52 27.0576 16.4692 27.0576 17.64C27.0576 18.8109 28.0068 19.76 29.1776 19.76ZM29.1776 20.76C30.9007 20.76 32.2976 19.3631 32.2976 17.64C32.2976 15.9169 30.9007 14.52 29.1776 14.52C27.4545 14.52 26.0576 15.9169 26.0576 17.64C26.0576 19.3631 27.4545 20.76 29.1776 20.76Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.52988 8.3L28.0502 8.81989L28.0306 9.8197L1.51028 9.29981L1.52988 8.3Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.80115 8.79998L8.80115 3.59998L9.80115 3.59998L9.80115 8.79998L8.80115 8.79998Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0796 8.79998L16.0796 3.59998L17.0796 3.59998L17.0796 8.79998L16.0796 8.79998Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.80115 1.51997L8.80115 3.59998L7.80115 3.59998L7.80115 1.51997L8.80115 1.51997Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.1588 1.51997L18.1588 3.59998L17.1588 3.59998L17.1588 1.51997L18.1588 1.51997Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.63844 0.499999L21.2784 0.499999L21.2784 1.5L4.63844 1.5L4.63844 0.499999Z\" />\n            <path d=\"M1 15.5L1.5 9H27.5L35 11L37 14V17.5H32L30.5 15H28L26.5 17.5H11L9 15.5H6.5L4.5 17.5L2.5 16.5L1 15.5Z\" />\n            </svg>";
    }
  }, {
    key: "vehicleTruckSVG",
    get: function get() {
      return "<svg class=\"ico-vehicle\" width=\"38\" height=\"19\" viewBox=\"0 0 38 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.27881 17.085C9.44966 17.085 10.3988 16.1358 10.3988 14.965C10.3988 13.7941 9.44966 12.845 8.27881 12.845C7.10797 12.845 6.15881 13.7941 6.15881 14.965C6.15881 16.1358 7.10797 17.085 8.27881 17.085ZM8.27881 18.085C10.0019 18.085 11.3988 16.6881 11.3988 14.965C11.3988 13.2418 10.0019 11.845 8.27881 11.845C6.55569 11.845 5.15881 13.2418 5.15881 14.965C5.15881 16.6881 6.55569 18.085 8.27881 18.085Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.7003 17.085C30.8712 17.085 31.8203 16.1358 31.8203 14.965C31.8203 13.7941 30.8712 12.845 29.7003 12.845C28.5295 12.845 27.5803 13.7941 27.5803 14.965C27.5803 16.1358 28.5295 17.085 29.7003 17.085ZM29.7003 18.085C31.4235 18.085 32.8203 16.6881 32.8203 14.965C32.8203 13.2418 31.4235 11.845 29.7003 11.845C27.9772 11.845 26.5803 13.2418 26.5803 14.965C26.5803 16.6881 27.9772 18.085 29.7003 18.085Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3972 1.44507C12.3972 1.16893 12.6211 0.945068 12.8972 0.945068H22.4165C22.5247 0.945068 22.63 0.980157 22.7165 1.04507C23.5206 1.64813 24.7548 2.64143 25.8519 3.66804C26.4002 4.18111 26.9215 4.70925 27.3394 5.20609C27.7473 5.69101 28.0949 6.19007 28.2454 6.64155C28.3328 6.90352 28.1912 7.18668 27.9292 7.274C27.6672 7.36133 27.3841 7.21975 27.2968 6.95778C27.2093 6.69531 26.9669 6.31681 26.5741 5.8498C26.1913 5.39471 25.7012 4.89656 25.1686 4.3982C24.1624 3.45663 23.0308 2.53845 22.249 1.94507H13.3972V6.79966C13.3972 7.07581 13.1734 7.29966 12.8972 7.29966C12.6211 7.29966 12.3972 7.07581 12.3972 6.79966V1.44507Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 9.20264C0.5 7.82192 1.61929 6.70264 3 6.70264H33.6973C35.6303 6.70264 37.1973 8.26964 37.1973 10.2026V15.6292L31.9377 15.6292L31.9377 14.6292L36.1973 14.6292V10.2026C36.1973 8.82193 35.078 7.70264 33.6973 7.70264H3C2.17157 7.70264 1.5 8.37421 1.5 9.20264V13.1291C1.5 13.9576 2.17159 14.6292 3.00004 14.6291L5.75963 14.6291L5.75965 15.6291L3.00006 15.6291C1.61932 15.6292 0.5 14.5099 0.5 13.1291V9.20264ZM10.9203 14.6291H26.5831V15.6291H10.9203V14.6291Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.4874 6.79964L16.4874 1L17.4874 1L17.4874 6.79964L16.4874 6.79964Z\" />\n            <path d=\"M1 14V8.5L2 7.5H34L36.5 8.5V15H33L31 12.5H28.5L26.5 15H11L10 12.5H7L5.5 15H3L1 14Z\" />\n            </svg>";
    }
  }, {
    key: "vehicleVanSVG",
    get: function get() {
      return "<svg class=\"ico-vehicle\" width=\"39\" height=\"19\" viewBox=\"0 0 39 19\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.4187 6.13955L31.6412 6.13961L31.6412 7.13961L21.4187 7.13955L21.4187 6.13955Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9112 1.02012L21.9102 15.3301L20.9102 15.33L20.9112 1.02005L21.9112 1.02012Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.18778 2.87423C3.02739 3.21461 2.82712 3.92594 2.61938 4.90235C2.41308 5.87197 2.20899 7.0547 2.03254 8.28702C1.7088 10.548 1.48427 12.9334 1.50076 14.458L4.07313 14.83H5.33468C5.61082 14.83 5.83468 15.0538 5.83468 15.33C5.83468 15.6061 5.61082 15.83 5.33468 15.83H4.03716C4.01322 15.83 3.9893 15.8282 3.9656 15.8248L0.941128 15.3874C0.703989 15.3531 0.524514 15.1554 0.513244 14.9161C0.438788 13.3349 0.686825 10.6303 1.04263 8.14529C1.22137 6.89699 1.42914 5.69128 1.64127 4.69425C1.84953 3.71542 2.072 2.88707 2.29211 2.42919C2.40597 2.19235 2.61794 2.03179 2.80953 1.92085C3.01267 1.80321 3.26288 1.70187 3.54063 1.61223C4.09771 1.43244 4.83488 1.27801 5.6913 1.14585C7.40867 0.880816 9.67516 0.695063 12.0975 0.592849C16.9342 0.388761 22.4709 0.514695 25.5899 1.03452C25.6526 1.04497 25.7128 1.06728 25.7671 1.10025C26.5106 1.55138 27.7158 2.39193 28.8676 3.34112C29.9491 4.23246 31.0375 5.26286 31.6298 6.18345L36.673 8.30845C36.7555 8.34321 36.8271 8.39947 36.8805 8.47137C37.0292 8.67195 37.1836 8.9864 37.3307 9.36888C37.4816 9.76132 37.6364 10.2566 37.7759 10.8398C38.0549 12.0067 38.276 13.5401 38.276 15.33C38.276 15.6061 38.0521 15.83 37.776 15.83H32.1828C31.9066 15.83 31.6828 15.6061 31.6828 15.33C31.6828 15.0538 31.9066 14.83 32.1828 14.83H37.2699C37.2337 13.3362 37.0388 12.0572 36.8033 11.0724C36.6726 10.5258 36.5302 10.0734 36.3973 9.72773C36.2982 9.46988 36.21 9.28646 36.1433 9.17041L31.0945 7.04307C30.9959 7.00152 30.9133 6.92945 30.8587 6.83743C30.3878 6.04388 29.3639 5.04601 28.2316 4.11282C27.1554 3.22593 26.0354 2.44085 25.3302 2.00527C22.2963 1.5157 16.9057 1.39085 12.1397 1.59196C9.73544 1.69341 7.50982 1.87704 5.84382 2.13415C5.00855 2.26305 4.33122 2.40787 3.84777 2.5639C3.60525 2.64217 3.42868 2.71788 3.31064 2.78623C3.22365 2.8366 3.19342 2.86865 3.18778 2.87423ZM10.1827 15.33C10.1827 15.0538 10.4065 14.83 10.6827 14.83H26.5297C26.8058 14.83 27.0297 15.0538 27.0297 15.33C27.0297 15.6061 26.8058 15.83 26.5297 15.83H10.6827C10.4065 15.83 10.1827 15.6061 10.1827 15.33Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.12966 17.3971C9.27133 17.3971 10.1968 16.4716 10.1968 15.33C10.1968 14.1883 9.27133 13.2628 8.12966 13.2628C6.988 13.2628 6.0625 14.1883 6.0625 15.33C6.0625 16.4716 6.988 17.3971 8.12966 17.3971ZM8.12966 18.3971C9.82361 18.3971 11.1968 17.0239 11.1968 15.33C11.1968 13.636 9.82361 12.2628 8.12966 12.2628C6.43572 12.2628 5.0625 13.636 5.0625 15.33C5.0625 17.0239 6.43572 18.3971 8.12966 18.3971Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.1824 17.3971C30.3241 17.3971 31.2496 16.4716 31.2496 15.33C31.2496 14.1883 30.3241 13.2628 29.1824 13.2628C28.0407 13.2628 27.1152 14.1883 27.1152 15.33C27.1152 16.4716 28.0407 17.3971 29.1824 17.3971ZM29.1824 18.3971C30.8763 18.3971 32.2496 17.0239 32.2496 15.33C32.2496 13.636 30.8763 12.2628 29.1824 12.2628C27.4885 12.2628 26.1152 13.636 26.1152 15.33C26.1152 17.0239 27.4885 18.3971 29.1824 18.3971Z\" />\n            <path d=\"M2 4.62069L3 2.55172L10 1.51724L21 1V15.4828H11L9.5 13H7L5 15L1 14.9655V13.4138L2 4.62069Z\" />\n            </svg>";
    }
  }, {
    key: "vehicleOtherSVG",
    get: function get() {
      return "<svg class=\"ico-vehicle\" width=\"34\" height=\"20\" viewBox=\"0 0 34 20\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.3488 18.8999C30.696 18.8999 32.5988 16.9971 32.5988 14.6499C32.5988 12.3027 30.696 10.3999 28.3488 10.3999C26.0015 10.3999 24.0988 12.3027 24.0988 14.6499C24.0988 16.9971 26.0015 18.8999 28.3488 18.8999ZM28.3488 19.8999C31.2482 19.8999 33.5988 17.5494 33.5988 14.6499C33.5988 11.7504 31.2482 9.3999 28.3488 9.3999C25.4493 9.3999 23.0988 11.7504 23.0988 14.6499C23.0988 17.5494 25.4493 19.8999 28.3488 19.8999Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.25 18.8999C7.59721 18.8999 9.5 16.9971 9.5 14.6499C9.5 12.3027 7.59721 10.3999 5.25 10.3999C2.90279 10.3999 1 12.3027 1 14.6499C1 16.9971 2.90279 18.8999 5.25 18.8999ZM5.25 19.8999C8.14949 19.8999 10.5 17.5494 10.5 14.6499C10.5 11.7504 8.14949 9.3999 5.25 9.3999C2.3505 9.3999 0 11.7504 0 14.6499C0 17.5494 2.3505 19.8999 5.25 19.8999Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.2813 0.533834C23.4127 0.584815 23.5165 0.688922 23.5671 0.820511L28.8172 14.4705C28.9163 14.7282 28.7877 15.0175 28.53 15.1167C28.2722 15.2158 27.9829 15.0872 27.8838 14.8295L22.8315 1.6935L21.2241 2.49721C20.9771 2.62071 20.6768 2.5206 20.5533 2.27361C20.4298 2.02662 20.5299 1.72628 20.7769 1.60279L22.8769 0.552787C23.003 0.489736 23.1498 0.482853 23.2813 0.533834Z\" />\n            <path d=\"M18.1014 5.19983C21.7014 5.19983 22.9348 6.94983 23.1014 7.82483L22.6014 9.39983C20.4348 9.04983 15.9014 8.24483 15.1014 7.82483C14.3014 7.40483 13.1014 5.89983 12.6014 5.19983H18.1014Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.1569 4.97104C12.2426 4.8045 12.4141 4.69983 12.6014 4.69983H18.1014C21.8697 4.69983 23.3688 6.55633 23.5926 7.73127C23.6081 7.81284 23.6031 7.89698 23.578 7.97612L23.078 9.55112C23.003 9.78732 22.7663 9.93295 22.5217 9.89343C21.4345 9.71781 19.7535 9.42803 18.2419 9.12908C17.4866 8.97969 16.769 8.8271 16.1871 8.68453C15.6289 8.54774 15.133 8.40611 14.869 8.26753C14.3808 8.01119 13.8281 7.4662 13.3665 6.95096C12.8898 6.41886 12.4534 5.85284 12.1946 5.49045C12.0857 5.33804 12.0712 5.13757 12.1569 4.97104ZM13.6142 5.69983C13.7694 5.89077 13.9378 6.08994 14.1114 6.2837C14.5748 6.80096 15.0221 7.21847 15.3339 7.38213C15.4699 7.45356 15.8407 7.57005 16.4251 7.71326C16.986 7.85069 17.6871 7.99997 18.436 8.14808C19.7479 8.40756 21.1921 8.66065 22.2556 8.83663L22.5822 7.80796C22.3801 7.15804 21.334 5.69983 18.1014 5.69983H13.6142Z\" />\n            <path d=\"M5.53085 6.26106C7.78447 6.26105 10.7897 6.16158 13.4192 6.55947L14.8994 7.69995L16.8004 8.34996L3.27731 8.34999C2.90166 7.95209 3.27724 6.26108 5.53085 6.26106Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.65303 5.75585C8.72193 5.74172 11.2428 5.72449 13.494 6.06514C13.5779 6.07783 13.6572 6.11166 13.7244 6.16344L15.1392 7.25357L16.9622 7.87689C17.1935 7.95599 17.3337 8.1908 17.2936 8.43199C17.2535 8.67318 17.0449 8.84999 16.8004 8.84999L3.27732 8.85002C3.13972 8.85002 3.00821 8.79332 2.91375 8.69327C2.68191 8.4477 2.63244 8.09858 2.65572 7.81489C2.68082 7.5089 2.79511 7.17641 3.00764 6.87085C3.44524 6.24171 4.26952 5.76111 5.53086 5.7611C5.88542 5.7611 6.26112 5.75853 6.65303 5.75585ZM6.6815 6.75592C6.28345 6.75855 5.89845 6.7611 5.53086 6.7611C4.53859 6.7611 4.04827 7.12602 3.82859 7.44186C3.72659 7.5885 3.67559 7.73356 3.65786 7.85002L14.2749 7.85L13.2172 7.03507C11.0844 6.72685 8.71291 6.74251 6.6815 6.75592Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.0386 9.94983L11.0427 9.94983C11.0506 9.94983 11.0586 9.95002 11.0665 9.9504L22.0678 10.4754C22.2123 10.4823 22.3467 10.5514 22.4364 10.665C22.526 10.7785 22.5621 10.9253 22.5353 11.0675L21.4464 16.8424C21.3966 17.1068 21.1466 17.2843 20.8806 17.2442L10.4237 15.6693C10.1507 15.6281 9.96266 15.3734 10.0038 15.1004C10.0449 14.8273 10.2996 14.6393 10.5727 14.6804L20.553 16.1836L21.4461 11.4468L11.0307 10.9498C10.7549 10.9498 10.2453 10.9511 9.74138 11.0118C9.48572 11.0426 9.24588 11.0872 9.04695 11.1489C8.83966 11.2131 8.72177 11.2824 8.66753 11.3347C8.46876 11.5264 8.15223 11.5207 7.96054 11.3219C7.76884 11.1232 7.77458 10.8066 7.97334 10.6149C8.19133 10.4047 8.48177 10.2771 8.75086 10.1937C9.02832 10.1077 9.33292 10.0538 9.62171 10.019C10.1964 9.94972 10.7653 9.9498 11.0386 9.94983Z\" />\n            <path d=\"M29.9222 3.625C27.4022 3.625 26.7722 4.39203 26.7722 5.2C26.7722 6.88 28.8722 6.775 29.9222 6.775V3.625Z\" />\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.6656 4.53454C27.3531 4.72815 27.2722 4.95338 27.2722 5.2C27.2722 5.50545 27.3633 5.68733 27.4807 5.812C27.6093 5.94852 27.8099 6.05807 28.0883 6.13602C28.5002 6.25136 28.9785 6.27271 29.4222 6.27558V4.13651C28.5065 4.18072 27.9688 4.34664 27.6656 4.53454ZM27.1389 3.68448C27.7291 3.31879 28.6285 3.125 29.9222 3.125C30.1984 3.125 30.4222 3.34886 30.4222 3.625V6.775C30.4222 7.05114 30.1984 7.275 29.9222 7.275C29.8694 7.275 29.8122 7.27536 29.7512 7.27574C29.2447 7.2789 28.4783 7.28368 27.8187 7.09898C27.4408 6.99317 27.0508 6.81398 26.7528 6.49769C26.4437 6.16954 26.2722 5.73455 26.2722 5.2C26.2722 4.63865 26.5063 4.07639 27.1389 3.68448Z\" />\n            </svg>";
    }
  }, {
    key: "restaurantOffCanvasShown",
    get: function get() {
      return this._restaurantOffCanvasShown;
    },
    set: function set(_restaurantOffCanvasShown) {
      var _this13 = this;

      runInAction(function () {
        _this13._restaurantOffCanvasShown = _restaurantOffCanvasShown;
      });
    }
  }, {
    key: "vehicleOffCanvasShown",
    get: function get() {
      return this._vehicleOffCanvasShown;
    },
    set: function set(_vehicleOffCanvasShown) {
      var _this14 = this;

      runInAction(function () {
        _this14._vehicleOffCanvasShown = _vehicleOffCanvasShown;
      });
    }
  }, {
    key: "showModal",
    get: function get() {
      return this._showModal;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._showModal = val;
      });
    }
  }, {
    key: "checkSummary",
    get: function get() {
      return this._checkSummary;
    }
  }, {
    key: "eClubUrl",
    get: function get() {
      var _this$_appAttributes9, _this$_appAttributes10;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes9 = this._appAttributes) === null || _this$_appAttributes9 === void 0 ? void 0 : (_this$_appAttributes10 = _this$_appAttributes9.configs) === null || _this$_appAttributes10 === void 0 ? void 0 : _this$_appAttributes10.eclubUrl;
    }
  }, {
    key: "curbsideSurveyUrl",
    get: function get() {
      var _this$_appAttributes11, _this$_appAttributes12;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes11 = this._appAttributes) === null || _this$_appAttributes11 === void 0 ? void 0 : (_this$_appAttributes12 = _this$_appAttributes11.configs) === null || _this$_appAttributes12 === void 0 ? void 0 : _this$_appAttributes12.curbsideSurveyUrl;
    }
  }, {
    key: "isEclubAvailable",
    get: function get() {
      return !!i18next.t("text.curbside_eclub");
    }
  }, {
    key: "isSurveyAvailable",
    get: function get() {
      return !!i18next.t("text.curbside_survey");
    }
  }, {
    key: "isPromoRichTextAvailable",
    get: function get() {
      return !!i18next.t("text.curbside_promo");
    }
  }, {
    key: "orderType",
    get: function get() {
      var _this$checkSummary11, _this$checkSummary11$, _this$checkSummary11$2;

      var dpID = (_this$checkSummary11 = this.checkSummary) === null || _this$checkSummary11 === void 0 ? void 0 : (_this$checkSummary11$ = _this$checkSummary11.orderSummary) === null || _this$checkSummary11$ === void 0 ? void 0 : (_this$checkSummary11$2 = _this$checkSummary11$.orderIDs) === null || _this$checkSummary11$2 === void 0 ? void 0 : _this$checkSummary11$2.orderID.filter(function (orderID) {
        return orderID.source === "DP";
      });
      return dpID && dpID.length ? "online" : "offline";
    }
  }, {
    key: "checkInThresholdTime",
    get: function get() {
      var _this$_checkSummary, _this$_checkSummary2; // this is ISO time from DASH and has timezone


      var checkInAvailableAfter = moment.parseZone((_this$_checkSummary = this._checkSummary) === null || _this$_checkSummary === void 0 ? void 0 : _this$_checkSummary.orderSummary.checkInAvailableAfter).format("YYYY-MM-DDTHH:mm:ss.sss"); // pickUpDateTime from DASH is ZULU time format but its local time.

      var pickUpDateTime = moment((_this$_checkSummary2 = this._checkSummary) === null || _this$_checkSummary2 === void 0 ? void 0 : _this$_checkSummary2.orderSummary.pickUpDateTime);
      return pickUpDateTime.diff(checkInAvailableAfter, "minutes");
    }
  }, {
    key: "showCurbsideBanner",
    get: function get() {
      var _this$_restaurant, _this$_restaurant$fea, _this$_checkSummary3, _this$checkSummary12, _this$checkSummary13, _this$checkSummary14;

      var CURBSIDE = "CURBSIDE";
      var WALKIN = "WALKIN";
      var isCurbsideTogoEnabled = (_this$_restaurant = this._restaurant) === null || _this$_restaurant === void 0 ? void 0 : (_this$_restaurant$fea = _this$_restaurant.features) === null || _this$_restaurant$fea === void 0 ? void 0 : _this$_restaurant$fea.curbSideTogoEnabled; // Make downwards compatible using vehicle information in case fulfillment method parameter is undefined

      var vehicleInformationAvailable = !!((_this$_checkSummary3 = this._checkSummary) !== null && _this$_checkSummary3 !== void 0 && _this$_checkSummary3.orderSummary.vehicleInformation);
      var fulfillmentMethodCompatibilityInit = vehicleInformationAvailable ? CURBSIDE : WALKIN;
      var fulfillmentMethod = ((_this$checkSummary12 = this.checkSummary) === null || _this$checkSummary12 === void 0 ? void 0 : _this$checkSummary12.orderSummary.fulfillmentMethod) === undefined ? fulfillmentMethodCompatibilityInit : (_this$checkSummary13 = this.checkSummary) === null || _this$checkSummary13 === void 0 ? void 0 : _this$checkSummary13.orderSummary.fulfillmentMethod;
      var isCurbsideFulfillmentMethod = fulfillmentMethod === CURBSIDE;
      var pickUpDateTime = (_this$checkSummary14 = this.checkSummary) === null || _this$checkSummary14 === void 0 ? void 0 : _this$checkSummary14.orderSummary.pickUpDateTime;
      var pickUpDate = moment(pickUpDateTime).format("YYYY-MM-DD");
      var isPickUpTimeValid = moment().isBetween(moment(pickUpDate), moment(pickUpDateTime));
      return isCurbsideTogoEnabled && isCurbsideFulfillmentMethod && !!pickUpDateTime && isPickUpTimeValid;
    }
  }, {
    key: "isCheckInAvailable",
    get: function get() {
      var _this$checkSummary$or2, _this$checkSummary15, _this$checkSummary16;

      var isCheckinThresholdValid = this.checkInThresholdTime > 0 && this.checkInThresholdTime < 60;
      var canUserCheckIn = ((_this$checkSummary$or2 = (_this$checkSummary15 = this.checkSummary) === null || _this$checkSummary15 === void 0 ? void 0 : _this$checkSummary15.orderSummary.checkInAvailable) !== null && _this$checkSummary$or2 !== void 0 ? _this$checkSummary$or2 : true) && !!!((_this$checkSummary16 = this.checkSummary) !== null && _this$checkSummary16 !== void 0 && _this$checkSummary16.orderSummary.checkInDateTime);
      return isCheckinThresholdValid && canUserCheckIn;
    }
  }, {
    key: "curbsideToken",
    get: function get() {
      return this._curbsideToken;
    },
    set: function set(_curbsideToken) {
      var _this16 = this;

      runInAction(function () {
        _this16._curbsideToken = _curbsideToken;
      });
    }
  }, {
    key: "checkInURL",
    get: function get() {
      return "/customer-service/curbside-checkin/?tkn=".concat(this.curbsideToken);
    }
  }, {
    key: "orderSummary",
    get: function get() {
      return this._orderSummary;
    },
    set: function set(_orderSummary) {
      var _this17 = this;

      runInAction(function () {
        _this17._orderSummary = _orderSummary;
      });
    }
  }, {
    key: "isOrderTrackingEnabled",
    get: function get() {
      var _this$_restaurant$fea2, _this$_restaurant2, _this$_restaurant2$fe;

      return (_this$_restaurant$fea2 = (_this$_restaurant2 = this._restaurant) === null || _this$_restaurant2 === void 0 ? void 0 : (_this$_restaurant2$fe = _this$_restaurant2.features) === null || _this$_restaurant2$fe === void 0 ? void 0 : _this$_restaurant2$fe.orderTrackingEnabled) !== null && _this$_restaurant$fea2 !== void 0 ? _this$_restaurant$fea2 : false;
    }
  }, {
    key: "tokenId",
    get: function get() {
      var _this$_checkSummary4, _this$_checkSummary4$;

      return (_this$_checkSummary4 = this._checkSummary) === null || _this$_checkSummary4 === void 0 ? void 0 : (_this$_checkSummary4$ = _this$_checkSummary4.orderSummary) === null || _this$_checkSummary4$ === void 0 ? void 0 : _this$_checkSummary4$.tokenID;
    }
  }, {
    key: "checkInSource",
    get: function get() {
      return this._checkInSource;
    },
    set: function set(_val) {
      var _this18 = this;

      runInAction(function () {
        _this18._checkInSource = _val;
      });
    }
  }, {
    key: "geoFenceEntryTimestamp",
    get: function get() {
      return this._geoFenceEntryTimestamp;
    }
  }, {
    key: "setGeoFenceEntryTimestamp",
    set: function set(timestamp) {
      var _this19 = this;

      runInAction(function () {
        _this19._geoFenceEntryTimestamp = timestamp;
      });
    }
  }, {
    key: "curbsideTransaction",
    get: function get() {
      return {
        transactionID: this.orderID,
        transactionStatus: "SUBMITTED",
        transactionType: this.orderType,
        attributes: {
          pickupDate: this.checkSummary.orderSummary.pickUpDateTime,
          pickupTime: formatAMPM(this.checkSummary.orderSummary.pickUpDateTime)
        },
        total: {
          priceTotal: this.totalAmount
        }
      };
    }
  }]);

  return CurbsideModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_inputMode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_parkingSpotValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_parkingSignInputFieldRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_parkingDescription", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_vehicleType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_vehicleColor", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_showModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_checkSummary", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_restaurant", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_restaurantOffCanvasShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_vehicleOffCanvasShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_curbsideToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_orderSummary", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_checkInSource", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_geoFenceEntryTimestamp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "maxParkingSpotNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxParkingSpotNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNumParkingSpotsAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNumParkingSpotsAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxCharacterLimitForDesc", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxCharacterLimitForDesc"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleTypes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleTypes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleColors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleColors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "brandName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "id", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dashOrderID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dashOrderID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parkingSpotNumberVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parkingSpotNumberVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipCodeFormatted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipCodeFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputMode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inputMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parkingSpotValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parkingSpotValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isParkingSpotAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isParkingSpotAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parkingSignInputFieldRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parkingSignInputFieldRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parkingDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parkingDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isParkingDescriptionAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isParkingDescriptionAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleColor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleCarSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleCarSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleSUVSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleSUVSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleTruckSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleTruckSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleVanSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleVanSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleOtherSVG", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleOtherSVG"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantOffCanvasShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantOffCanvasShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleOffCanvasShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleOffCanvasShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkSummary", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkSummary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eClubUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eClubUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "curbsideSurveyUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "curbsideSurveyUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEclubAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEclubAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSurveyAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSurveyAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPromoRichTextAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPromoRichTextAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkInThresholdTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInThresholdTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCurbsideBanner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCurbsideBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckInAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckInAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "curbsideToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "curbsideToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkInURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderSummary", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderSummary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderTrackingEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderTrackingEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tokenId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tokenId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkInSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkInSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "geoFenceEntryTimestamp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoFenceEntryTimestamp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "curbsideTransaction", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "curbsideTransaction"), _class.prototype)), _class);
export { CurbsideModel as default };